export default "__VITE_ASSET__Dyss$_C4__"